import React, { useState } from 'react'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'

import styles from './Dialog.module.sass'
import { useReload } from 'store'

const CreateThreadFromComment = (props) => {
	const { className, data, dismiss, resolve } = props
	const { i18n, expireSession, pushNotification } = useGlobal()
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)
	const reload = useReload()

	const handleSubmit = (e) => {
		e.preventDefault()
		if (submitting) {
			return
		}

		const url = `${API_URL}/api/clinical_processes/${data?.processId}/comments/parent`

		setError(null)
		setSubmitting(true)

		fetch(
			url,
			fetchOptions({
				method: 'PUT',
				body: { commentId: +data.commentId, parent: null },
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				reload([`/clinical_processes/${data?.processId}/comments`])
				setSubmitting(false)
				resolve && resolve(null)
				pushNotification(
					undefined,
					'success',
					i18n`Comment dissociated successfully!`
				)
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}

				setSubmitting(false)
			})
	}
	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<form
				id={`form_notifications`}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
				disabled={submitting}
			>
				<p>{i18n`This reply will no longer be associated with this comment.`}</p>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={`form_notifications`} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default CreateThreadFromComment
